import * as Yup from "yup";
import { forceInt } from "Utils";
import { transform as lockTransformer } from "./Lock";
import { transform as workflowTransformer } from "./Workflow";
import { transform as tagTransformer } from "./Tag";
import { transform as metaPropertyTransformer } from "./MetaProperty";
import { transform as contentTransformer } from "./Content";
import { fromSqlDateTime } from "../helpers/Date";

export const ContainerValidationSchema = Yup.object().shape({});

export const ContainerObjectSchema = {
    id: null,
    uuid: null,
    srn: null,
    slug: "",
    description: null,
    description_raw: null,
    title: "",
    type: null,
    created_at: null,
    modified_at: null,
    published_at: null,
    status: null,
    layout_template: "Default",
    sort_order: [],
    tags: [],
    metaProperties: [],
    content: [],
    placeholder: {},
    tag_all: null,
    object_type: "container",
};

/**
 * Transform API object to a Container object
 * @param {object} requestData JSON object from the API
 * @returns Object
 */
export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let edit_url;
    switch (requestData.type) {
        case "gallery":
            edit_url = `/app/gallery/${requestData.uuid}`;
            break;
        case "automatic":
        case "manual":
        default:
            edit_url = `/app/container/${requestData.uuid}`;
    }

    let container = Object.assign({}, ContainerObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        srn: requestData.srn,
        slug: requestData.slug,
        description: requestData.description,
        description_raw: requestData.description_raw,
        title: requestData.title,
        type: requestData.type,
        created_at: requestData.created_at,
        modified_at: requestData.modified_at,
        published_at: requestData.published_at,
        status: requestData.status,
        sort_order: requestData.sort_order,
        layout_template: requestData.layout_template
            ? requestData.layout_template
            : "Default",
        last_changed: fromSqlDateTime(requestData.modified_at).toMillis(),
        edit_url: edit_url,
        tag_all: requestData.tag_all,
    });

    if (requestData.lock) {
        let lock = lockTransformer(requestData.lock);
        container = Object.assign({}, container, { lock: lock });
    }

    if (requestData.placeholder) {
        let ph = contentTransformer(requestData.placeholder);
        container = Object.assign({}, container, { placeholder: ph });
    }

    if (requestData.workflow) {
        let wf = workflowTransformer(requestData.workflow);
        container = Object.assign({}, container, { workflow: wf });
    }

    if (requestData.tags) {
        container = Object.assign({}, container, {
            tags: tagTransformer(requestData.tags),
        });
    }

    if (requestData.content) {
        container = Object.assign({}, container, {
            content: contentTransformer(requestData.content),
        });
    }

    if (requestData.metaProperties) {
        container = Object.assign({}, container, {
            metaProperties: metaPropertyTransformer(requestData.metaProperties),
        });
    }

    return container;
}

/**
 * Serialize the container object to a string
 * @param {object} item
 * @returns string
 */
export function serialize(item) {
    return JSON.stringify(item);
}

/**
 * Deserialize json string
 * @param {string} item
 * @returns object
 */
export function deserialize(item) {
    return JSON.parse(item);
}

/**
 *
 * @param {object} item The object being saved
 * @param {object} resetVars Values to overwrite after preparation
 * @returns Object
 */
export function prepare(item, resetVars = {}) {
    return Object.assign(
        {},
        item,
        {
            last_changed: undefined,
            modified_at: undefined,
            edit_url: undefined,
            object_type: undefined,
            description_raw: "",
        },
        resetVars
    );
}
